import { defineComponent as _defineComponent } from 'vue'
import { onMounted, onBeforeUnmount, ref, nextTick } from 'vue';
import { startApp } from 'wujie';
import { InstanceofPlugin, SelectionPlugin, EventTargetPlugin } from 'wujie-polyfill';
import type { HiroEntryService, HiroBasicConfig, HostProps } from '@patsnap/hiro-event-proxy';
import { injectService } from '@patsnap/tahiti-core';
import { GlobalProxy } from '@patsnap/hiro-event-proxy';


export default /*#__PURE__*/_defineComponent({
  __name: 'HiroEntry',
  props: {
    service: null,
    defaultMenu: null,
    defaultAgentCode: null,
    agentCodeScope: null
  },
  setup(__props: any) {

const props = __props as {
    service: HiroEntryService;
    defaultMenu?: 'HiroChat' | 'HiroAgentManager';
    defaultAgentCode?: string;
    /**
     * 智能体 code 范围, 不在范围内的 agent 将被隐藏（可以从历史查看）
     * 不传则显示所有智能体
     * 传空数组则不显示任何智能体
     */
    agentCodeScope?: string[];
}



const containerRef = ref<HTMLElement>();
const hiroBasicConfig = ref<HiroBasicConfig | null>(null);
const wujieProps = ref<HostProps | null>(null);

const globalProxy = injectService<GlobalProxy>(GlobalProxy);

const _onLoaded = () => {
    if (props.defaultMenu && globalProxy.rpcHiro.isRegistered('setCurrentMenu')) {
        globalProxy.rpcHiro.call('setCurrentMenu', props.defaultMenu);
    }
    if (props.defaultAgentCode && globalProxy.rpcHiro.isRegistered('switchAgent')) {
        globalProxy.rpcHiro.call('switchAgent', {
            agentCode: props.defaultAgentCode,
        });
    }
};

onMounted(async() => {
    try {
        hiroBasicConfig.value = await props.service.getHiroBasicConfig();

        if (hiroBasicConfig.value && hiroBasicConfig.value.enabled) {
            wujieProps.value = props.service.getWujieProps(hiroBasicConfig.value);
            if (props.agentCodeScope) {
                // enabledAgentCodes 是开启权限的智能体 code，这里过滤掉不支持的智能体
                wujieProps.value.enabledAgentCodes = wujieProps.value.enabledAgentCodes.filter(code => props.agentCodeScope?.includes(code));
            }

            // 等待 DOM 更新
            await nextTick();

            if (containerRef.value) {
                // 将 containerRef 挂载到 document.body 的最后
                document.body.appendChild(containerRef.value);

                // !!! WujieVue 在 workspace 里无法正常工作，这里直接使用 wujie 的 startApp 方法
                startApp({
                    name: hiroBasicConfig.value.name,
                    url: hiroBasicConfig.value.url,
                    el: containerRef.value,
                    props: wujieProps.value,
                    plugins: [
                        InstanceofPlugin(),
                        SelectionPlugin(),
                        EventTargetPlugin()
                    ],
                    alive: true,
                    sync: false,
                });
            }
        }

        globalProxy.eventProxy.on('loaded', _onLoaded);
        _onLoaded();
    } catch (error) {
        console.error('Failed to load Hiro basic config:', error);
    }
});

onBeforeUnmount(() => {
    // 清理 DOM 元素
    if (containerRef.value && containerRef.value.parentNode === document.body) {
        document.body.removeChild(containerRef.value);
    }

    globalProxy.eventProxy.off('loaded', _onLoaded);
});


return { __sfc: true,props, containerRef, hiroBasicConfig, wujieProps, globalProxy, _onLoaded }
}

})